import notify from 'components/atoms/Notify'
import isEmpty from 'lodash/isEmpty'
import { parseCookies } from 'nookies'
import i18n from '../../i18n'
import refreshToken from './refreshToken'

const baseUrl = process.env.REACT_APP_BASE_URL

const apiGetBlob = async (url, showError = true, retryCount = 0) => {
  const { accessToken, workspaceID, role, impersonateToken, isImpersonated, impersonateRole, dashboardRole } = parseCookies()

  const config = {
    method: 'GET',
    headers: {
      'Accept-Language': i18n.language || 'en',
    },
  }

  if (!isEmpty(accessToken)) {
    config.headers = {
      Authorization: isImpersonated && impersonateToken ? impersonateToken : accessToken,
      workspaceID,
      ...config.headers,
    }
    if (role && !isImpersonated) {
      config.headers.role = role
    } else if (isImpersonated && impersonateRole) {
      config.headers.role = impersonateRole
    }
    if (dashboardRole && !isImpersonated) {
      config.headers['X-Dashboard-Role'] = dashboardRole
    }
  }

  const response = await fetch(`${baseUrl}/admin/${url}`, config)

  if (response.status === 403 && retryCount === 0 && !isImpersonated) {
    const refreshed = await refreshToken()
    if (refreshed) {
      return apiGetBlob(url, showError, retryCount + 1)
    } else {
      if (showError) {
        try {
          const responseData = await response.json()
          notify.error(responseData.message || 'Session expired. Please login again.', null, responseData.err)
        } catch {
          notify.error('Session expired. Please login again.')
        }
      }
      return null
    }
  }

  if (!response.ok) {
    if (showError) {
      try {
        const responseData = await response.json()
        notify.error(responseData.message || 'Failed to fetch file', null, responseData.err)
      } catch {
        notify.error('Failed to fetch file')
      }
    }
    return null
  }

  return await response.blob()
}

export default apiGetBlob

export const crmApiExportLeads = query => apiGetBlob(`crm/leads/export.csv?${query || ''}`)
